import type { ApplicationLabelsTranslations } from '../application-labels';

const en: ApplicationLabelsTranslations = {
  LABEL_ADD: 'Add label',
  LABEL_REMOVE: 'Remove label',
  LABEL_STANDARD: 'Standard label',
  LABEL_SYSTEM: 'Applied automatically - only an admin can remove this',
  LABEL_NO_LABELS: 'No labels yet',
  LABEL_SEARCH: 'Search labels...',
  LABEL_NO_MATCH: 'No labels found',
  LABEL_CREATE_NEW: 'Create new label',
  LABEL_NAME_PLACEHOLDER: 'Label name',
  LABEL_CANCEL: 'Cancel',
  LABEL_SAVE: 'Save',
  LABEL_SAVING: 'Saving...',
  label_not_interested: 'Not Interested',
  label_top_priority: 'Top Priority',
  label_follow_up: 'Follow Up',
  label_interview_scheduled: 'Interview Scheduled',
  label_offer_received: 'Offer Received',
  label_rejected: 'Rejected',
  label_saved_for_later: 'Saved for Later',
  label_no_response_expected: 'No Response Expected',
  label_batch_tailor: 'Batch Tailor',
};

export default en;
